import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=c38d0b64"
var script = {}
import style0 from "./Toolbar.vue?vue&type=style&index=0&id=c38d0b64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports